import { render } from "./charts-wrapper.vue?vue&type=template&id=687617ee"
const script = {}

import "./charts-wrapper.vue?vue&type=style&index=0&id=687617ee&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__